module.exports = __webpack_public_path__ + "img/e5868.015c889a.svg";